import script from "./report.vue?vue&type=script&setup=true&lang=js"
export * from "./report.vue?vue&type=script&setup=true&lang=js"

import "./report.vue?vue&type=style&index=0&id=2bb155cc&lang=scss"

const __exports__ = script;

export default __exports__